import { useQuery } from 'react-query';

import getQuotes from '@/ebat/api/quotes/getQuotes';

const useQuotes = (queryKey, disabled, keepPreviousData = true) =>
  useQuery(queryKey, getQuotes, {
    enabled: !disabled,
    keepPreviousData,
  });

export default useQuotes;
